'use client';
import React from 'react';
import Link from 'next/link';
import { cn } from '@/app/_lib/utils';
import moment from 'moment';

const Footer = ({ className }: { className?: string }) => {
  return (
    <footer className={cn('py-10 border-grey4 border-t', className)}>
      <div className="flex flex-col-reverse gap-2 md:gap-6 md:flex-row justify-between">
        <span className={cn('text-[12px] text-greyPurple')}>
          Copyright &copy; {moment().year()} Zoc
        </span>
        <span className={cn('flex flew-row text-[12px] gap-4 font-bold')}>
          <Link
            href="https://zoc.ai/privacy/"
            className="text-purple5 hover:text-purple9"
          >
            Privacy policy
          </Link>
          <Link
            href="https://zoc.ai/terms-of-service/"
            className="text-purple5 hover:text-purple9"
          >
            Terms of service
          </Link>
          <Link
            href="https://zoc.ai/disclaimer/"
            className="text-purple5 hover:text-purple9"
          >
            Disclaimer
          </Link>
        </span>
      </div>
    </footer>
  );
};

export default Footer;
